import { useMutation } from '@tanstack/react-query'

import { restartController } from '@/features/controller/endpoints/controllers'
import { useControllerRestartState } from '@/features/controller/restart/hooks/useControllerRestartState'
import type { ControllerRestartMethod } from '@/features/controller/restart/types'

export function useRestartControllerMutation(controllerId: string, restartMethod: ControllerRestartMethod) {
  const { setRestartInProgress } = useControllerRestartState(controllerId)

  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: () => restartController(controllerId, restartMethod),
    onSuccess: () => {
      // Only set the restart as "in progress" - let polling handle success/failure
      setRestartInProgress()
    },
  })

  return {
    restartController: mutateAsync,
    ...mutationResult,
  }
}
